// @refresh reload
import { ensureI18nInitializedServer, getLocaleByPath, i18next } from "@/i18n";
import { registerServiceWorker } from "@/lib/pwa.ts";
import * as Sentry from "@sentry/solidstart";
import { StartClient, mount } from "@solidjs/start/client";

import { useUrlStorage } from "./hooks/useUrlStorage";
import { setupTwaCommunication } from "./lib/twaBridge";
import { initDeviceInfo } from "./stores/deviceStore";
import { tryGetServerHash } from "./stores/sysConfigStore";

if (import.meta.env.VITE_ENV_NAME === "prod") {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    release: __APP_VERSION__,
    sendDefaultPii: true,
    environment: `${import.meta.env.VITE_APP_NAME}-${import.meta.env.VITE_ENV_NAME}-client`,
  });
}

// 仅在开发环境加载 eruda 调试工具
if (import.meta.env.MODE === "development") {
  // 添加错误捕获
  window.addEventListener("error", (event) => {
    console.error("全局错误捕获:", {
      message: event.error?.message,
      stack: event.error?.stack,
      filename: event.filename,
      lineno: event.lineno,
    });
  });

  import("eruda")
    .then((eruda) => {
      try {
        eruda.default.init();
        // console.log("eruda 调试工具启动成功");

        // 测试 import.meta.env 是否正常
        // console.log("环境变量测试:", {
        //   MODE: import.meta.env.MODE,
        //   DEV: import.meta.env.DEV,
        //   PROD: import.meta.env.PROD,
        // });
      } catch (error) {
        console.error("eruda 初始化失败:", error);
      }
    })
    .catch((error) => {
      console.error("eruda 导入失败:", error);
    });
}
if (window.jsThirdBridge) {
  window.jsbridge = window.jsThirdBridge;
}
const appDom = document.getElementById("app");
if (!appDom) {
  throw new Error("Wrapper div not found");
}

// 注册PWA Service Worker
registerServiceWorker();
// 初始化 TWA Bridge 通信
setupTwaCommunication();
initDeviceInfo();
const { parseUrl } = useUrlStorage();
parseUrl(decodeURIComponent(window.location.href));
tryGetServerHash();

(async () => {
  try {
    ensureI18nInitializedServer();
    await i18next.changeLanguage(getLocaleByPath(window.location.pathname));

    mount(() => <StartClient />, appDom ?? document.body);
  } catch (error) {
    console.error("Failed to initialize app:", error);
  }
})();
